module.exports = function() {
  return new Worker(__webpack_public_path__ + "25499aad4c354b761017.worker.js");
};